import React, { useEffect, useState } from 'react';
import '../../styles/manageplacement.css';

const PlacementsManager = () => {
  const [placements, setPlacements] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch all placements
  const fetchPlacements = async () => {
    try {
      const response = await fetch('http://localhost:5000/api/placements');
      const data = await response.json();
      setPlacements(data);
    } catch (error) {
      setErrorMessage('Error fetching placements');
    }
  };

  // Delete placement
  const handleDelete = async (id) => {
    try {
      const response = await fetch(`http://localhost:5000/api/placements/${id}`, {
        method: 'DELETE',
      });

      const data = await response.json();  // Get the response data

      if (response.ok) {
        // Successfully deleted, remove the placement from the state
        setPlacements((prevPlacements) =>
          prevPlacements.filter((placement) => placement._id !== id)
        );
      } else {
        setErrorMessage(data.message || 'Error deleting placement');
      }
    } catch (error) {
      console.error('Error deleting placement:', error);  // Log any errors
      setErrorMessage('Error deleting placement');
    }
  };

  useEffect(() => {
    fetchPlacements();  // Fetch placements when the component loads
  }, []);

  return (
    <div>
      <h2>Manage Placements</h2>
      
      {errorMessage && <p>{errorMessage}</p>}

      <div className="placement-list">
        {placements.length > 0 ? (
          placements.map((placement) => (
            <div key={placement._id} className="placement-card">
              <img
                src={placement.imageUrl}
                alt={placement.name}
                width="150"
                height="150"
              />
              <p>Name: {placement.name}</p>
              <p>Company: {placement.company}</p>
              <button onClick={() => handleDelete(placement._id)}>Delete</button>
            </div>
          ))
        ) : (
          <p>No placements available.</p>
        )}
      </div>
    </div>
  );
};


export default PlacementsManager;
